// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "ticket-1Cba6";
var _4 = "notes-3uA8I";
var _5 = "header-14Ugi";
var _6 = "transparent-2SMTa";
var _7 = "info-1xxZi";
var _8 = "title-ROFBf";
var _9 = "createPrefix-3DwoW";
var _a = "time-2G65U";
var _b = "status-30s_G";
var _c = "comments-7ayv3";
var _d = "commentsTitle-eYiEq";
var _e = "filesTitle-3Zbb1";
var _f = "commentsText-1asvI";
var _10 = "filesContent-1uFRj";
var _11 = "breadcrumbs-22fai";
var _12 = "files-2T8zT";
var _13 = "prices-1aIon";
var _14 = "price-3nikw";
var _15 = "file-4r719";
var _16 = "fileIcon-3m3ZB";
var _17 = "buttons-1iqta";
var _18 = "button-1BRhG";
var _19 = "confirm-38dXU";
var _1a = "reject-3fK2R";
var _1b = "refund__request-3S3an";
var _1c = "step-erRYH";
var _1d = "reasonHeader-1Py-j";
var _1e = "reasonDescr-1MhLg";
export { _1 as "__esModule", _2 as "mobile", _3 as "ticket", _4 as "notes", _5 as "header", _6 as "transparent", _7 as "info", _8 as "title", _9 as "createPrefix", _a as "time", _b as "status", _c as "comments", _d as "commentsTitle", _e as "filesTitle", _f as "commentsText", _10 as "filesContent", _11 as "breadcrumbs", _12 as "files", _13 as "prices", _14 as "price", _15 as "file", _16 as "fileIcon", _17 as "buttons", _18 as "button", _19 as "confirm", _1a as "reject", _1b as "refund__request", _1c as "step", _1d as "reasonHeader", _1e as "reasonDescr" }
export default { "__esModule": _1, "mobile": _2, "ticket": _3, "notes": _4, "header": _5, "transparent": _6, "info": _7, "title": _8, "createPrefix": _9, "time": _a, "status": _b, "comments": _c, "commentsTitle": _d, "filesTitle": _e, "commentsText": _f, "filesContent": _10, "breadcrumbs": _11, "files": _12, "prices": _13, "price": _14, "file": _15, "fileIcon": _16, "buttons": _17, "button": _18, "confirm": _19, "reject": _1a, "refund__request": _1b, "step": _1c, "reasonHeader": _1d, "reasonDescr": _1e }
